var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDispatchOngoing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ffdb00",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.951 18.232a6.71 6.71 0 0 0-5.047-2.296.248.248 0 0 0-.246.245l-.225 4.1-13.179.292a.247.247 0 0 0-.246.248v2.583c0 .138.11.249.246.249h19.38a.247.247 0 0 0 .246-.249v-2.78c0-.859-.31-1.686-.874-2.33l-.055-.062z",
    stroke: "#000",
    strokeWidth: 0.717,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.807 10.688a1.943 1.943 0 0 0-1.932 1.948v6.502c0 1.075.867 1.949 1.932 1.949H21.08a1.943 1.943 0 0 0 1.932-1.949v-6.502a1.943 1.943 0 0 0-1.932-1.948H9.807z",
    stroke: "#000",
    strokeWidth: 0.717,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.868 15.746-3.154-2.729a.326.326 0 0 0-.351-.049.331.331 0 0 0-.191.3v1.283h-5.156a.33.33 0 0 0-.329.332v2.068a.33.33 0 0 0 .329.332h5.156v1.282a.331.331 0 0 0 .328.331.327.327 0 0 0 .206-.073l3.154-2.568a.332.332 0 0 0 .008-.51",
    stroke: "#000",
    strokeWidth: 0.844,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.925 23.736c0 .84-.676 1.523-1.51 1.523-.835 0-1.511-.682-1.511-1.523 0-.842.676-1.524 1.51-1.524.835 0 1.511.682 1.511 1.524",
    fill: "#013177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.414 22.543c-.652 0-1.182.535-1.182 1.193 0 .657.53 1.192 1.182 1.192.652 0 1.183-.535 1.183-1.192 0-.658-.53-1.193-1.183-1.193zm0 3.047a1.849 1.849 0 0 1-1.84-1.854 1.85 1.85 0 0 1 1.84-1.855 1.85 1.85 0 0 1 1.84 1.855 1.849 1.849 0 0 1-1.84 1.854z",
    fill: "#013177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.006 18.295-.055-.063c-.861-.984-1.417-1.69-2.671-2.045a.245.245 0 0 0-.313.24v3.367c0 .138.11.25.246.25h3.313a.246.246 0 0 0 .196-.098.251.251 0 0 0 .043-.215 3.547 3.547 0 0 0-.76-1.436z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.013 21.88a1.85 1.85 0 0 0-1.839 1.856c0 1.022.825 1.854 1.84 1.854 1.014 0 1.839-.832 1.839-1.854a1.85 1.85 0 0 0-1.84-1.855M25.414 21.88a1.85 1.85 0 0 0-1.84 1.856c0 1.022.826 1.854 1.84 1.854 1.014 0 1.84-.832 1.84-1.854a1.85 1.85 0 0 0-1.84-1.855",
    stroke: "#000",
    strokeWidth: 0.741,
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatchOngoing);
export default __webpack_public_path__ + "static/media/dispatch_ongoing.bb87b64bf79bb82b591a9d901431c1b0.svg";
export { ForwardRef as ReactComponent };